import React, { Component } from 'react';
import Text from "../../main/Text";
import BackButton from '../../main/BackButton';



class Returns extends Component {
  render() {
    return (
      <>

        <BackButton />

        <Text>all sales final. no returns. no refunds. no exchanges. </Text>

      </>
    );
  }
}
export default Returns;

